module.exports = __webpack_public_path__ + "static/media/logo.dd42e40a.png";